import { render } from "./SectionStudentAttendance.vue?vue&type=template&id=74c4f5b1"
import script from "./SectionStudentAttendance.vue?vue&type=script&lang=js"
export * from "./SectionStudentAttendance.vue?vue&type=script&lang=js"

import "./SectionStudentAttendance.vue?vue&type=style&index=0&id=74c4f5b1&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__